<template>
  <div v-loading="loading" class="nx-page meterenergy-analysis">
    <el-card shadow="never">
      <div slot="header" class="card-head">
        <span>用量热力分析（抄表）</span>
        <div class="filters">
          <el-date-picker v-model="billingMonth" type="month" value-format="yyyyMM" clearable size="small" style="width: 150px" />
          <el-input-number v-model="monthCount" :min="3" :max="24" size="small" style="width: 120px" />
          <span class="lbl">个月</span>
          <el-button type="primary" size="small" @click="load">查询</el-button>
        </div>
      </div>
      <div class="chart-title">费目 × 账单月</div>
      <div ref="chartFee" class="chart-box tall" />
      <div class="chart-title mt16">电类目 × 账单月（kWh）</div>
      <div ref="chartCat" class="chart-box tall" />
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { fetchHeatAnalysis } from './api'

const FEE_LABEL = { 1: '电', 2: '水', 3: '暖', 4: '污水' }

export default {
  name: 'MeterEnergyHeat',
  data() {
    return { loading: false, billingMonth: null, monthCount: 6, data: {}, charts: [] }
  },
  mounted() {
    this.load()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    this.charts.forEach((c) => c.dispose())
  },
  methods: {
    resize() {
      this.charts.forEach((c) => c.resize())
    },
    async load() {
      this.loading = true
      try {
        const res = await fetchHeatAnalysis({
          billingMonth: this.billingMonth || undefined,
          monthCount: this.monthCount
        })
        this.data = (res.data && res.data.data) || {}
        this.$nextTick(() => this.renderCharts())
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    renderCharts() {
      this.charts.forEach((c) => c.dispose())
      this.charts = []
      const d = this.data
      const months = d.months || []
      const feeTypes = [1, 2, 3, 4]
      const feeLabels = feeTypes.map((ft) => FEE_LABEL[ft] || String(ft))
      const feeCells = d.feeMonthHeat || []
      const feeData = []
      feeTypes.forEach((ft, yi) => {
        months.forEach((m, xi) => {
          const hit = feeCells.find((c) => Number(c.feeType) === ft && c.billingMonth === m)
          feeData.push([xi, yi, hit ? Number(hit.usageAmount) || 0 : 0])
        })
      })
      const maxF = Math.max(1, ...feeData.map((x) => x[2]))
      const ch1 = echarts.init(this.$refs.chartFee)
      ch1.setOption({
        tooltip: {
          position: 'top',
          formatter: (p) => {
            const v = p.data
            return feeLabels[v[1]] + ' / ' + months[v[0]] + '<br/>' + v[2]
          }
        },
        grid: { left: 64, right: 48, top: 16, bottom: 48 },
        xAxis: { type: 'category', data: months, splitArea: { show: true } },
        yAxis: { type: 'category', data: feeLabels, splitArea: { show: true } },
        visualMap: { min: 0, max: maxF, calculable: true, orient: 'horizontal', left: 'center', bottom: 4, inRange: { color: ['#ecfdf5', '#059669', '#064e3b'] } },
        series: [{ type: 'heatmap', data: feeData, label: { show: true, fontSize: 9 }, emphasis: { itemStyle: { shadowBlur: 8 } } }]
      })
      this.charts.push(ch1)

      const catCells = d.electricCategoryMonthHeat || []
      const cats = [...new Set(catCells.map((c) => c.category).filter(Boolean))].sort()
      const catData = []
      cats.forEach((cat, yi) => {
        months.forEach((m, xi) => {
          const hit = catCells.find((c) => c.category === cat && c.billingMonth === m)
          catData.push([xi, yi, hit ? Number(hit.usageAmount) || 0 : 0])
        })
      })
      const maxC = Math.max(1, ...catData.map((x) => x[2]))
      const ch2 = echarts.init(this.$refs.chartCat)
      ch2.setOption({
        tooltip: {
          position: 'top',
          formatter: (p) => {
            const v = p.data
            return cats[v[1]] + ' / ' + months[v[0]] + '<br/>' + v[2] + ' kWh'
          }
        },
        grid: { left: 100, right: 48, top: 16, bottom: 48 },
        xAxis: { type: 'category', data: months, splitArea: { show: true } },
        yAxis: { type: 'category', data: cats, splitArea: { show: true } },
        visualMap: { min: 0, max: maxC, calculable: true, orient: 'horizontal', left: 'center', bottom: 4, inRange: { color: ['#fff7ed', '#fb923c', '#9a3412'] } },
        series: [{ type: 'heatmap', data: catData, label: { show: true, fontSize: 8 }, emphasis: { itemStyle: { shadowBlur: 8 } } }]
      })
      this.charts.push(ch2)
    }
  }
}
</script>

<style scoped>
.card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.filters {
  display: flex;
  gap: 8px;
  align-items: center;
}
.lbl {
  font-size: 13px;
  color: #64748b;
}
.chart-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}
.chart-box.tall {
  height: 380px;
  width: 100%;
}
.mt16 {
  margin-top: 16px;
}
</style>
